import { useCallback } from 'react';

import PropTypes from 'prop-types';
import { getLowerCaseSelector } from 'utils/clickme';
import { FILTER_STATUS_SENDING } from 'utils/constants/invoice';

import InputText, { InputType } from 'bloko/blocks/inputText';
import Select, { Option } from 'bloko/blocks/select';

import useTrls from 'hooks/translation/useTrls';

import { InvoiceFilterType, setFilterValue } from 'store/models/invoices';
import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/Invoices/Filter/FilterValue/FilterValue.less';

const statusItems = [FILTER_STATUS_SENDING, 'waiting_doc', 'new', 'prepaid', 'payed', 'closed', 'overdue', 'cancel'];

const FilterValue = ({ onClick }) => {
    const { filterType, filterValue } = useSelector((state) => state.invoices);

    const dispatch = useDispatch();

    const trl = useTrls();

    const onChangeValue = useCallback(
        (value) => {
            dispatch(setFilterValue(value));
        },
        [dispatch]
    );
    const isKeyEnter = (event) => {
        if (event.key === 'Enter') {
            onClick();
        }
    };
    switch (filterType) {
        case InvoiceFilterType.Status:
            return (
                <div className="filter-value__status">
                    <Select value={filterValue} onChange={onChangeValue}>
                        {statusItems.map((item) => (
                            <Option key={item} value={item}>
                                {trl(`InvoiceStatus.${getLowerCaseSelector(item)}`)}
                            </Option>
                        ))}
                    </Select>
                </div>
            );
        case InvoiceFilterType.Manual:
            return null;
        default:
            return (
                <InputText
                    type={filterType === InvoiceFilterType.InvoiceName ? InputType.Text : InputType.Number}
                    value={filterValue}
                    onChange={onChangeValue}
                    placeholder={trl('admin.Invoices.Filter.FilterValue.placeholder')}
                    size="30"
                    data-qa="search-field"
                    onKeyDown={isKeyEnter}
                />
            );
    }
};

FilterValue.propTypes = {
    onClick: PropTypes.func,
};

export default FilterValue;
